<template>
  <transition name="toast">
    <div class="toast-wrapper">
      <div class="toast-container" :class="type" :style="containerStyle">
          <button class="close btn btn-icon" @click="$emit('close')">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z"/></svg>
          </button>
        <div class="toast-body">
          <p class="body-5 mb-0" v-html="message"></p>
        </div>
        <div class="toast-footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'ToastNotification',

    mounted: function() {
      setTimeout(() => {
        this.$emit('close');
      }, this.timeout)
    },

    props: {
      message: {
        default: '',
        type: String
      },
      type: {
        default: '',
        type: String
      },
      timeout: {
        default: 7000,
        type: Number
      }
    },

    computed: {
      containerStyle() {
        return {
          '--animation-duration': (this.timeout / 1000) + 's'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .toast-mask {
    @apply fixed pin-t pin-l w-full h-full;
    z-index: 9998;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
  }

  .toast-wrapper {
    @apply fixed;
    left: 50%;
    top: 25px;
    transform: translateX(-50%);
    z-index: 998;
  }

  .toast-container {
    @apply relative mx-auto bg-white;
    width: 600px;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    border-color: lighten(#989898, 30%);
    @apply border-b-5 border-solid;

    &:after {
      content: '';
      position: absolute;
      height: 5px;
      @apply bg-grey-2;
      left: 0;
      bottom: -5px;
      animation-name: border-width;
      animation-duration: var(--animation-duration);
      animation-timing-function: linear;
    }

    &.error {
      border-color: lighten(#f00, 30%);

      &:after {
        @apply bg-danger;
      }
    }

    &.success {
      border-color: lighten(#28a745, 30%);

      &:after {
        @apply bg-success;
      }
    }

    .close {
      @apply absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
      height: 25px;

      svg {
        @apply fill-current h-6 w-6 text-grey-2;
      }
    }

    .toast-body {
      @apply py-3 pr-8 pl-3;
    }
  }

  @keyframes border-width {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  @keyframes drop-out {
    0% {
      @apply opacity-100;
    }
    50% {
      @apply opacity-50;
    }
    100% {
      @apply opacity-0;
    }
  }

  @keyframes drop-in {
    0% {
      @apply opacity-0;
      top: -200px;
    }
    50% {
      @apply opacity-50;
    }
    100% {
      @apply opacity-100;
      top: 25px;
    }
  }

  .toast-leave-active {
    animation: drop-out 0.5s ease-out;
  }

  .toast-enter-active {
    animation: drop-in 0.5s ease;
  }
</style>
